<!--
 * @Description: 线索管理-基本信息新增 编辑 详情
 * /marketing/ClueManage/view 线索跟踪详情
   /marketing/clueReleaseRecord/view 线索投放记录详情
   /marketing/ClueManage/view 线索管理列表详情
   /marketing/ClueManage/edit 线索管理编辑
   /marketing/ClueManage/add 线索管理新增
 * @Author: cxh
-->
<template>
  <a-form ref="formRef" name="advanced_search" :model="form">
    <dc-layout-card title="基本信息">
      <dc-form-item
        name="customerName"
        label="客户名称"
        :rules="{
          required: true,
          message: '请输入'
        }"
      >
        <div style="display: flex; align-content: center">
        <CosInput
          v-model:value="form.customerName"
          :maxlength="50"
          placeholder="请输入"
          :disabled="disabled"
          :view="view"
        />
        <CustomerInfoParse v-if="!view" @success="parseCustomerInfo"></CustomerInfoParse>
        </div>
      </dc-form-item>
      <dc-form-item
        label="来源渠道"
        name="channel"
        :rules="{
          required: true,
          message: '请选择'
        }"
      >
        <a-input-group compact class="cos-view-input-group">
          <ParamCodeCascader
            v-model:value="form.channel"
            :options="paramCodeData.zbu_source_channel_fbu"
            :cosDes="form.channelExplain"
            :disabled="disabled"
            :view="view"
            style="width: 33%"
          />
          <a-form-item style="width: 67%" class="last-compact" name="channelExplain">
            <CosInput v-model:value="form.channelExplain" placeholder="请输入" :disabled="disabled" :view="view" />
          </a-form-item>
        </a-input-group>
      </dc-form-item>
      <dc-form-item
        label="客户办公地"
        name="customerOffice"
        :rules="{
          validator: areaValidate,
          trigger: 'blur'
        }"
      >
        <customer-area
          v-model:value="form.customerOffice"
          v-model:label="form.customerOfficeName"
          change-on-select
          :disabled="disabled"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="客户类型">
        <CosSelect
          v-model:value="form.customerType"
          :options="dataConfig.customerTypeEnum"
          placeholder="请选择"
          allow-clear
          :disabled="disabled"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="标签">
        <CosSelect
          mode="multiple"
          v-model:value="form.customerTag"
          :options="tagLIst"
          placeholder="请选择"
          allow-clear
          :disabled="disabled"
          :view="view"
          :fieldNames="{ label: 'name', value: 'name' }"
        />
      </dc-form-item>
      <dc-form-item label="是否产业带" :name="['business', 'industrialBeltFlag']">
        <CosRadioGroup
          v-model:value="form.business.industrialBeltFlag"
          @change="changeIndustrialBeltFlag"
          :options="dataConfig.flagEnum"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item
        label="产业带"
        :name="['business', 'industrialBelt']"
        :rules="{
          message: '请选择',
          validator: selectForNumberValidate,
        }"
        v-if="form.business.industrialBeltFlag === 1"
      >
        <ParamCodesSelect
          :options="paramCodeData.zbu_industrial_belt_fbu"
          v-model:value="form.business.industrialBelt"
          v-model:label="form.business.industrialBeltLabel"
          :view="view"
          @change="changeIndustrialBeltLabel"
        />
      </dc-form-item>
      <dc-form-item
        label="产业带名称"
        :name="['business', 'industrialBeltName']"
        v-if="form.business.industrialBelt && form.business.industrialBeltLabel === '其他'"
        :rules="{
          message: '请输入',
          required: true
        }"
      >
        <CosInput v-model:value="form.business.industrialBeltName" :maxlength="100" placeholder="请输入" :view="view" />
      </dc-form-item>
      <dc-form-item name="originalRegion" label="客户原始区域">
        <CustomerAreaCascader appId="cos_fbu" deptInfoId="815717" v-model:value="form.originalRegion" :view="view" />
      </dc-form-item>
      <dc-form-item label="创建时间" v-if="view">
        <CosInput v-model:value="form.createTime" :disabled="disabled" :view="view" />
      </dc-form-item>
      <a-col :span="24" />
      <dc-form-item label="备注" :span="12">
        <CosTextarea v-model:value="form.remark" :maxlength="2000" :disabled="disabled" :view="view" />
      </dc-form-item>
    </dc-layout-card>
    <dc-layout-card title="联系人信息">
      <dc-form-item
        :name="['contact', 'name']"
        :rules="[
          {
            required: true,
            message: '请输入'
          },
          {
            validator: concatNameValidate
          }
        ]"
        label="联系人名称"
      >
        <CosInput v-model:value="form.contact.name" placeholder="请输入" :disabled="disabled" :view="view" />
      </dc-form-item>
      <dc-form-item label="性别">
        <CosSelect
          v-model:value="form.contact.sex"
          placeholder="请选择"
          allow-clear
          :options="dataConfig.genderEnum"
          :disabled="disabled"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="角色">
        <CosSelect
          v-model:value="form.contact.jobRole"
          placeholder="请选择"
          allow-clear
          :disabled="disabled"
          :view="view"
          :options="dataConfig.linkRoleTypeEnum"
        />
      </dc-form-item>
      <dc-form-item
        :name="['contact', 'mobile']"
        label="手机号"
        :rules="[
          {
            validator: (rule, value) => contactValidate(rule, value, form.contact, formRef)
          }
        ]"
      >
        <CosInput v-model:value="form.contact.mobile" placeholder="请输入" :disabled="disabled" :view="view" />
      </dc-form-item>
      <dc-form-item
        :name="['contact', 'email']"
        label="邮箱"
        :rules="[
          {
            validator: (rule, value) => contactValidate(rule, value, form.contact, formRef)
          }
        ]"
      >
        <CosInput v-model:value="form.contact.email" placeholder="请输入" :disabled="disabled" :view="view" />
      </dc-form-item>
      <dc-form-item
        :name="['contact', 'wechat']"
        label="微信号"
        :rules="{
          validator: (rule, value) => contactValidate(rule, value, form.contact, formRef)
        }"
      >
        <CosInput v-model:value="form.contact.wechat" placeholder="请输入" :disabled="disabled" :view="view" />
      </dc-form-item>
      <dc-form-item
        :name="['contact', 'qq']"
        label="QQ号"
        :rules="{
          validator: (rule, value) => contactValidate(rule, value, form.contact, formRef)
        }"
      >
        <CosInput v-model:value="form.contact.qq" placeholder="请输入" :disabled="disabled" :view="view" />
      </dc-form-item>
      <dc-form-item
        :name="['contact', 'tel']"
        label="固定电话"
        :rules="{
          validator: (rule, value) => contactValidate(rule, value, form.contact, formRef)
        }"
      >
        <CosInput v-model:value="form.contact.tel" placeholder="请输入" :disabled="disabled" :view="view" />
      </dc-form-item>
      <a-col :span="24" />
      <dc-form-item label="联系人备注" :span="12">
        <CosTextarea v-model:value="form.contact.remark" :maxlength="2000" :disabled="disabled" :view="view" />
      </dc-form-item>
    </dc-layout-card>
    <dc-layout-card title="业务信息">
      <dc-form-item label="产品货型">
        <ParamCodesSelect
          mode="multiple"
          :options="paramCodeData.zbu_product_type_fbu"
          v-model:value="form.business.cargoType"
          :disabled="disabled"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="销售平台">
        <ParamCodesSelect
          mode="multiple"
          :options="paramCodeData.zbu_channel_detail_fbu"
          v-model:value="form.business.salePlatform"
          :disabled="disabled"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="需求海外仓" :name="['business', 'warehouse']">
        <ParamCodesSelect
          mode="multiple"
          :options="paramCodeData.zbu_demand_info_fbu"
          v-model:value="form.business.warehouse"
          :disabled="disabled"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="发货地" :name="['business', 'shipAddress']">
        <CosInput v-model:value="form.business.shipAddress" placeholder="请输入" :disabled="disabled" :view="view" />
      </dc-form-item>
      <dc-form-item label="销售品类">
        <ParamCodesSelect
          mode="multiple"
          :options="paramCodeData.zbu_sales_category_fbu"
          v-model:value="form.business.salesCategory"
          :disabled="disabled"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="跨境月销售额">
        <ParamCodesSelect
          mode="multiple"
          :options="paramCodeData.zbu_monthly_sales_fbu"
          v-model:value="form.business.monthSales"
          :disabled="disabled"
          :view="view"
        />
      </dc-form-item>

      <dc-form-item label="服务需求">
        <ParamCodesSelect
          mode="multiple"
          :options="paramCodeData.zbu_service_demand_fbu"
          v-model:value="form.business.serviceNeeds"
          :disabled="disabled"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="客户类别" :rules="{
            required: true,
            message: '请选择'
          }">
        <ParamCodesSelect
          mode="multiple"
          :options="paramCodeData.zbu_customer_category_fbu"
          v-model:value="form.business.customerCategory"
          :disabled="disabled"
          :view="view"
        />
      </dc-form-item>
    </dc-layout-card>
    <dc-layout-card title="投放信息" v-if="view">
      <dc-form-item label="销售线索ID">
        <CosInput v-model:value="form.track.acceptorClueId" placeholder="请选择" :disabled="disabled" :view="view" />
      </dc-form-item>
      <dc-form-item label="客户代码">
        <CosInput v-model:value="form.track.customerNumber" placeholder="请选择" :disabled="disabled" :view="view" />
      </dc-form-item>
      <dc-form-item label="当前跟进人">
        <CosInput v-model:value="form.track.followerName" placeholder="请选择" :disabled="disabled" :view="view" />
      </dc-form-item>
      <dc-form-item name="customerRegion" label="客户区域">
        <CustomerAreaCascader appId="cos_fbu" v-model:value="form.track.customerRegion" :view="view" />
      </dc-form-item>
      <dc-form-item label="当前阶段">
        <CosSelect
          v-model:value="form.track.stage"
          :options="dataConfig.customerStageEnum"
          placeholder="请选择"
          allow-clear
          :disabled="disabled"
          :view="view"
        >
        </CosSelect>
      </dc-form-item>
      <dc-form-item label="当前状态">
        <CosSelect
          v-model:value="form.track.status"
          :options="dataConfig.customerAllStatusEnum"
          placeholder="请选择"
          allow-clear
          :disabled="disabled"
          :view="view"
        >
        </CosSelect>
      </dc-form-item>
      <dc-form-item label="投放时间">
        <CosInput v-model:value="form.track.createTime" :disabled="disabled" :view="view" />
      </dc-form-item>
      <dc-form-item label="领取时间">
        <CosInput v-model:value="form.track.salesCollectionTime" :disabled="disabled" :view="view" />
      </dc-form-item>
      <dc-form-item label="转潜在时间">
        <CosInput v-model:value="form.track.turnPotentialTime" :disabled="disabled" :view="view" />
      </dc-form-item>
      <dc-form-item label="转为签约时间">
        <CosInput v-model:value="form.track.turnContractTime" :disabled="disabled" :view="view" />
      </dc-form-item>
      <dc-form-item label="转为成交时间">
        <CosInput v-model:value="form.track.turnCustomerTime" :disabled="disabled" :view="view" />
      </dc-form-item>
      <dc-form-item label="成交额">
        <CosInput v-model:value="form.track.clinchAmount" :disabled="disabled" :view="view" />
      </dc-form-item>
      <dc-form-item label="无效时间">
        <CosInput v-model:value="form.track.invalidTime" :disabled="disabled" :view="view" />
      </dc-form-item>
      <dc-form-item label="无效原因">
        <CosInput v-model:value="form.track.invalidReason" placeholder="请输入" :disabled="disabled" :view="view" />
      </dc-form-item>
    </dc-layout-card>
    <dc-layout-card title="预投放信息" v-if="props.content.includes('expectPushInfo')">
      <template #subTitle>
        <a-button type="primary" v-if="!view && form.expectPushInfo.length < 1" ghost @click="handleAddCol"
          >新增</a-button
        >
      </template>
      <dc-layout-empty
        type="nothing"
        style="display: block; margin: 0 auto"
        v-if="!form.expectPushInfo || !form.expectPushInfo.length"
      />
      <MultipleItem :view="view" :line="false" v-else>
        <template v-for="(item, index) in form.expectPushInfo" :key="`expectPushInfo${index}`">
          <dc-form-item :label="index ? '' : '投放到'" :class="[index ? 'no-form-label' : '']" :span="8">
            <CosSelect
              :options="[
                {
                  value: 'cos_fbu',
                  label: '谷仓'
                },
                {
                  value: 'cos_ofbu',
                  label: '谷仓海外'
                }
              ]"
              v-model:value="item.acceptor"
              :view="view"
            />
          </dc-form-item>
          <dc-form-item :label="index ? '' : '客户区域'" :class="[index ? 'no-form-label' : '']" :span="8">
            <CustomerAreaCascader
              appId="cos_fbu"
              deptInfoId="815717"
              v-model:value="item.region"
              :view="view"
              @change="(value) => regionChange(item,value)"
              placeholder="请选择客户区域"
            />
          </dc-form-item>
          <dc-form-item :label="index ? '' : '客户负责人'" :class="[index ? 'no-form-label' : '']" :span="8">
            <div class="flex">
              <UserSelect v-model:value="item.follower" placeholder="请选择" allowClear :view="view" @onSelect="(value) => principalChange(item,value)"/>
              <a-button type="text" v-if="!view" @click="handleDelCol" danger style="padding: 0 0 0 12px"
                >删除</a-button
              >
            </div>
          </dc-form-item>
        </template>
      </MultipleItem>
    </dc-layout-card>
  </a-form>
  <cos-footer-button
    v-if="!disabled"
    v-model:value="form"
    :formRef="formRef"
    :hideOk="hideOk"
    :resetValue="resetValue"
    :loading="loading"
    :permissionPage="permissionPage"
    @submit="handleSubmit"
    :disabled="disabled"
  >
  </cos-footer-button>
</template>
<script setup lang="ts">
import { onMounted, nextTick, ref, PropType, onActivated } from 'vue'
import type { Rule } from 'ant-design-vue/es/form'
import CustomerArea from '@/components/CustomerArea/index'
import dataConfig from '@/views/marketing/commonEnum/dataConfig'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { listByParamCodes } from '@/api/common'
import { clueDetail, clueAdd, clueEdit, parentLabelList, clueTrackDetail } from '@/api/marketing/marketingManage'
import type { ClueManage } from '@/typings/api/marketingManage'
import { DropListType } from '@/typings/common'
import { DcConfirm, message } from '@dc-platform/dc-components'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import { contactValidate, concatNameValidate, selectForNumberValidate } from '@/utils/validate'
import { goBack } from '@/hooks/cosRouter'
import { paramCodesDataFilter } from '@/utils/index'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'
import CustomerInfoParse from '@/components/customerInfoParse/index.vue'
import UserSelect from '@/components/UserSelect/src/userSelect.vue'
const route = useRoute()

const emit = defineEmits(['fetchLaunch', 'detail'])
const props = defineProps({
  view: {
    type: Boolean
  },
  disabled: {
    type: Boolean
  },
  hideOk: {
    type: Boolean,
    default: false
  },
  content: {
    type: Object as PropType<'base' | 'contact' | 'business' | 'launch'[]>,
    default: () => {
      return ['base', 'contact', 'business']
    }
  },
  permissionPage: {
    type: Object
  }
})
const init: ClueManage = {
  customerTag: [],
  business: {
    cargoType: [],
    salePlatform: [],
    warehouse: [],
    monthSales: [],
    serviceNeeds: [],
    cooperation: []
  },
  expectPushInfo: [{}],
  contact: {},
  launch: {},
  track: {}
}
const form = ref<ClueManage>(cloneDeep(init))
const resetValue = ref<ClueManage>(cloneDeep(init))
const formRef = ref()
const loading = ref(false)
const tagLIst = ref<DropListType>([])
const paramCodeData = ref<any>({
  zbu_source_channel_fbu: [], // 线索来源渠道
  zbu_product_type_fbu: [], // 产品货型
  zbu_channel_detail_fbu: [], // 销售平台
  zbu_demand_info_fbu: [], // 需求海外仓
  zbu_monthly_sales_fbu: [], // 跨境月销售额
  zbu_service_demand_fbu: [], // 服务需求
  zbu_industrial_belt_fbu: [], // 产业带
  zbu_sales_category_fbu: [], // 销售品类
  zbu_customer_category_fbu: [] // 客户类别
})
const areaValidate = async (rule: Rule, value: string) => {
  if (form.value.customerOfficeName) {
    const lastArea = form.value.customerOfficeName.split('/')
    if (lastArea[lastArea.length - 1]?.includes('深圳')) {
      return Promise.reject(new Error('客户区域，深圳市必须精确到区'))
    } else {
      return Promise.resolve()
    }
  } else {
    return Promise.resolve()
  }
}
// 获取标签下拉框
const getTag = () => {
  parentLabelList().then((res) => {
    tagLIst.value = res.data
  })
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_zbu',
    paramCodes: [
      'zbu_source_channel_fbu',
      'zbu_product_type_fbu',
      'zbu_channel_detail_fbu',
      'zbu_demand_info_fbu',
      'zbu_monthly_sales_fbu',
      'zbu_service_demand_fbu',
      'zbu_industrial_belt_fbu',
      'zbu_sales_category_fbu',
      'zbu_customer_category_fbu'
    ]
  }).then((res) => {
    if (res.code === 200) {
      if (!props.view) {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, 0)
      }
      paramCodeData.value = res.data
    }
  })
}
/// 选择负责人后吧该负责人的区域带出来
const principalChange = (record: any, user: any) => {
  if (user) {
    record.principalRegion = user.deptId
    record.region = user.deptId
  }
}
/// 谷仓为了选择区域后把不是该区域的负责人给清空
const regionChange = (record: any, region: any) => {
  if (region && region.custom && region.custom !== record.principalRegion) {
    record.follower = undefined
    record.followerName = undefined
  }
}
/// 文本识别
const parseCustomerInfo = (parseInfo: any) => {
  if (!parseInfo) {
    return
  }
  let allBlank = false
  if (!form.value.contact.name && !form.value.contact.mobile && !form.value.remark) {
    allBlank = true
  }
  if (allBlank) {
    form.value.contact.name = parseInfo.contactName
    form.value.contact.mobile = parseInfo.phoneNum
    form.value.remark = parseInfo.detail + ' ' + parseInfo.address
    return
  }
  DcConfirm.warning({
    title: '操作提示！',
    content: '是否替换原内容',
    cancelText: '取消',
    okText: '继续',
    onOk() {
      form.value.contact.name = parseInfo.contactName
      form.value.contact.mobile = parseInfo.phoneNum
      form.value.remark = parseInfo.detail + ' ' + parseInfo.address
    }
  })
}
const changeIndustrialBeltFlag = () => {
  const { industrialBeltFlag } = form.value.business
  if (industrialBeltFlag === 0) {
    form.value.business.industrialBelt = -9
    form.value.business.industrialBeltLabel = ''
    form.value.business.industrialBeltName = ''
  }
}
const changeIndustrialBeltLabel = () => {
  nextTick(() => {
    const { industrialBeltLabel } = form.value.business
    if (industrialBeltLabel !== '其他') {
      form.value.business.industrialBeltName = ''
    }
  })
}

// 获取基本信息详情
const fetch = () => {
  if (route.query.clueId) {
    loading.value = true
    clueDetail({
      clueId: route.query.clueId
    })
      .then((res) => {
        const { expectPushInfo } = res.data
        form.value = {
          ...res.data,
          track: res.data.track || {},
          launch: form.value.launch || {},
          expectPushInfo: expectPushInfo && expectPushInfo.length ? expectPushInfo : [{}]
        }
        emit('detail', form.value)
        resetValue.value = cloneDeep(res.data)
      })
      .finally(() => {
        loading.value = false
      })
  }
}
defineExpose({
  fetch
})
const handleAddCol = () => {
  form.value.expectPushInfo.push({
    acceptor: 'cos_fbu'
  })
}
const handleDelCol = (arr: {}[], index: number) => {
  form.value.expectPushInfo.splice(index, 1)
}
// 获取投放信息详情
const fetchLaunch = () => {
  if (props.content.includes('launch') && route.query.id) {
    loading.value = true
    clueTrackDetail({
      cluePushTrackId: Number(route.query.id)
    })
      .then((res) => {
        form.value.launch = res.data
        emit('fetchLaunch', res.data)
      })
      .finally(() => {
        loading.value = false
      })
  }
}

onMounted(() => {
  getTag()
  getByParamCodes()
  fetch()
  fetchLaunch()
})
onActivated(() => {
  getTag()
})
const handleSubmit = async () => {
  // 过滤预投放信息
  const expectPushInfo = form.value.expectPushInfo?.filter((item) => item.acceptor || item.region || item.follower)
  expectPushInfo?.forEach((item) => {
    item.principalRegion = undefined
  })
  console.log(expectPushInfo)
  const p = {
    ...form.value,
    expectPushInfo
  }
  try {
    loading.value = true
    if (route.query.clueId) {
      await clueEdit(p)
      message.success('编辑成功')
    } else {
      await clueAdd(p)
      message.success('新增成功')
    }
    goBack()
  } catch (error) {
    loading.value = false
  }
  loading.value = false
}
</script>
<script lang="ts">
export default { name: 'BaseMessage' }
</script>
